export default function parseNumber(val) {
  const float_val = !isNaN(parseFloat(val.replace(/,/g, '')))
    ? parseFloat(val.replace(/,/g, ''))
    : 0;
  return float_val;
}
